<template>
  <v-card
    variant="tonal"
    class="mb-2"
    v-for="preset in Object.values(customState)">
    <v-card-title>
      <v-icon class="mr-3">mdi-alert</v-icon>
      {{ preset.display_name }}
    </v-card-title>
  </v-card>
</template>
<script setup lang="ts">
const props = defineProps(['customState', 'masterObj']);
</script>
<style scoped></style>
